<template>
  <el-card :body-style="{ padding: '8px 0' }" class="mt-2">
    <div class="dayplanner-suggestion-item">
      <div style="display: flex; flex-direction: column; margin-top: 0.5em">
        <div style="display: flex; width: 250px">
          <div class="dayplanner-suggestion-item-icon">
            <!--<EditableIcon v-model="icon" :is-editable="isEditable"/>-->
          </div>
          <div>
            <div>
              <span class="sessions-effort-text" style="cursor: pointer">{{ name }}</span>
            </div>
          </div>
        </div>
      </div>

      <div style="display: flex; flex-direction: column; justify-content: flex-end">
        <div>
          <el-button
            size="mini"
            @click="onAddItem"
            style="float: right; margin-right: 8px; width: 60px"
          >add</el-button>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
// import EditableIcon from "@/components/RoutineCreatorPage/Elements/EditableIcon";

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  computed: {},
  methods: {
    onAddItem() {
      this.$emit("add", this.itemId);
    }
  },
  components: {
    // EditableIcon
  }
};
</script>
